import KeenSlider from "keen-slider";

class LogosRow {
  constructor() {
    const el = document.querySelector(".c-logos-row-items");
    if (!el) return;

    var logosrowslider = new KeenSlider(
      el,
      {
        selector: ".c-logos-row-item",
        slides: {
          perView: 3,
          spacing: 0,
          align: "center",
        },
        drag: false,
        defaultAnimation: {
          duration: 1000,
        },
        breakpoints: {
          "(min-width: 991px)": {
            disabled: true,
          },
        },
      },
      []
    );
  }
}

export default LogosRow;
